/* Little Lebanese — site v1 behaviour. No dependencies. Shared by static preview + Shopify sections. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('ll-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* ---- scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('.ll-rv').forEach(function (el) { io.observe(el); });
  } else { $$('.ll-rv').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---- header shadow ---- */
  var hdr = $('.ll-header');
  if (hdr) { var onS = function () { hdr.classList.toggle('is-stuck', scrollY > 8); }; addEventListener('scroll', onS, { passive: true }); onS(); }

  /* ---- live cover ----
     Known names (data-fronts) show the real pre-rendered cover art (ads/set-1/work/cover/front_<Name>.jpg).
     Any other name shows the text-free cover with the title typeset in the same fonts and positions. */
  var AR = { maya: 'مايا', layan: 'ليان', nour: 'نور', yara: 'يارا', karim: 'كريم', george: 'جورج' };
  function fit(el, name) {
    var n = (name || '').length + 12, fs = Math.min(7.17, 62 / (0.5 * n));
    el.style.setProperty('--fs', fs.toFixed(2) + 'cqw');
  }
  function isBoy(book) { return book.getAttribute('data-gender') === 'boy' && !!book.getAttribute('data-front-src-boy'); }
  function swapFront(book, key) {
    var img = $('[data-ll-front]', book), tpl = book.getAttribute(isBoy(book) ? 'data-front-src-boy' : 'data-front-src');
    if (!img || !tpl) return;
    var src = tpl.replace('{n}', key);
    if (img.getAttribute('src') === src && !book.classList.contains('is-fading')) return;
    book.classList.add('is-fading');
    setTimeout(function () {
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        img.removeAttribute('srcset'); img.src = src;
        img.alt = 'Book cover: ' + key.charAt(0).toUpperCase() + key.slice(1) + ' Visits Teta in Lebanon';
        requestAnimationFrame(function () { book.classList.remove('is-fading'); });
      };
      pre.src = src;
    }, reduce ? 0 : 280);
  }
  /* boy/girl: the text-free base under custom names follows the chosen child */
  function setBlank(book) {
    var bl = $('.ll-cv--blank', book), boySrc = book.getAttribute('data-blank-src-boy');
    if (!bl || !boySrc) return;
    if (!bl.hasAttribute('data-girl-src')) { bl.setAttribute('data-girl-src', bl.getAttribute('src')); bl.setAttribute('data-girl-srcset', bl.getAttribute('srcset') || ''); }
    if (isBoy(book)) { if (bl.getAttribute('src') !== boySrc) { bl.removeAttribute('srcset'); bl.src = boySrc; } }
    else if (bl.getAttribute('src') !== bl.getAttribute('data-girl-src')) { bl.src = bl.getAttribute('data-girl-src'); var ss = bl.getAttribute('data-girl-srcset'); if (ss) bl.setAttribute('srcset', ss); }
  }
  function setCover(book, en, ar, gender, fromCycle) {
    if (!book) return;
    if (gender) book.setAttribute('data-gender', String(gender).toLowerCase() === 'boy' ? 'boy' : 'girl');
    var boy = isBoy(book);
    setBlank(book);
    var clean = (en || '').replace(/\s+/g, ' ').trim();
    var shown = clean || (boy ? book.getAttribute('data-default-name-boy') || 'Karim' : book.getAttribute('data-default-name') || 'Maya');
    var key = shown.toLowerCase(), a = (ar || '').trim();
    var fronts = (book.getAttribute(boy ? 'data-fronts-boy' : 'data-fronts') || '').split(',');
    var known = fronts.indexOf(key) > -1 && (!a || a === AR[key]);
    var nm = $('[data-ll-name]', book), arEl = $('[data-ll-arname]', book), h = $('.ll-cv-h', book);
    if (nm) nm.textContent = shown;
    if (h) fit(h, shown);
    if (arEl) {
      var txt = a || AR[key] || '';
      arEl.textContent = txt || '…'; arEl.classList.toggle('is-ph', !txt);
    }
    if (known) { book.classList.remove('is-custom'); swapFront(book, key); }
    else book.classList.add('is-custom');
    if (!fromCycle) $$('[data-ll-name-echo]').forEach(function (e) { e.textContent = shown; });
  }
  window.LLsetCover = setCover;

  /* hero: gently cycle through the real example covers until the visitor types */
  $$('[data-ll-cycle]').forEach(function (book) {
    var names = book.getAttribute('data-ll-cycle').split(','), i = 0, stop = false, t;
    book._stopCycle = function () { stop = true; clearTimeout(t); };
    if (reduce) return;
    /* entries are "Name" (girl art) or "boy:Name" (boy art) */
    names.forEach(function (n) { var b = n.indexOf('boy:') === 0, tpl = book.getAttribute(b ? 'data-front-src-boy' : 'data-front-src'); if (tpl) { var im = new Image(); im.src = tpl.replace('{n}', n.replace('boy:', '').toLowerCase()); } });
    (function loop() { t = setTimeout(function () { if (stop) return; i = (i + 1) % names.length; var n = names[i], b = n.indexOf('boy:') === 0; setCover(book, n.replace('boy:', ''), '', b ? 'boy' : 'girl', true); loop(); }, 3200); })();
  });

  /* every "Personalise" CTA pointing at the product opens the guided personaliser on arrival (#personalise) */
  $$('a[data-ll-buy]').forEach(function (a) {
    var u = a.getAttribute('href') || '';
    if (/\/products\//.test(u) && u.indexOf('#') < 0) a.setAttribute('href', u + '#personalise');
  });

  /* "try your child's name" input -> cover + CTA links carry ?name= */
  $$('[data-ll-tryname]').forEach(function (inp) {
    var book = d.getElementById(inp.getAttribute('data-ll-tryname'));
    inp.addEventListener('input', function () {
      if (book && book._stopCycle) book._stopCycle();
      var v = inp.value.replace(/[^A-Za-z' \-]/g, '').slice(0, 12);
      if (v !== inp.value) inp.value = v;
      setCover(book, v, '');
      $$('a[data-ll-buy]').forEach(function (a) {
        var u = a.getAttribute('data-href') || a.getAttribute('href'); a.setAttribute('data-href', u);
        var hs = u.indexOf('#'), base = hs > -1 ? u.slice(0, hs) : u, hash = hs > -1 ? u.slice(hs) : '';
        a.href = v.trim() ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'name=' + encodeURIComponent(v.trim()) + hash : u;
      });
    });
  });

  /* ---- sticky buy bar: shows once the primary CTA scrolls away, hides when another CTA is visible ---- */
  var bar = $('.ll-sticky');
  if (bar && 'IntersectionObserver' in window) {
    var watched = $$('[data-ll-cta-watch]'), vis = new Set(), passed = false;
    /* product page: no hero CTA, so watch the personalisation form and the real add-to-cart button */
    if (!watched.length && $('[data-ll-goto-form]', bar)) watched = $$('[data-ll-launch], [data-ll-personalise]');
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) vis.add(e.target); else vis.delete(e.target);
        if (!e.isIntersecting && e.boundingClientRect.top < 0) passed = true;
      });
      bar.classList.toggle('is-on', passed && vis.size === 0);
    });
    watched.forEach(function (w) { so.observe(w); });
  }

  /* ---- peek carousel ---- */
  $$('[data-ll-peek]').forEach(function (wrap) {
    var track = $('.ll-peek__track', wrap), pages = $$('.ll-page', track), dots = $('.ll-dots', wrap);
    if (dots) pages.forEach(function () { dots.appendChild(d.createElement('i')); });
    function upd() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      pages.forEach(function (p, i) {
        var pc = p.offsetLeft + p.offsetWidth / 2, dd = Math.abs(pc - c);
        if (dd < bd) { bd = dd; best = i; }
        p.classList.toggle('is-out', dd > p.offsetWidth * 0.75);
      });
      if (dots) $$('i', dots).forEach(function (x, i) { x.classList.toggle('on', i === best); });
      wrap._cur = best;
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    addEventListener('resize', upd); upd();
    function go(dir) { var t = pages[Math.max(0, Math.min(pages.length - 1, (wrap._cur || 0) + dir))]; track.scrollTo({ left: t.offsetLeft - (track.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
    var pv = $('[data-ll-prev]', wrap), nx = $('[data-ll-next]', wrap);
    pv && pv.addEventListener('click', function () { go(-1); });
    nx && nx.addEventListener('click', function () { go(1); });
  });

  /* ---- hear Teta player: real audio if data-src is set, otherwise a soft placeholder melody (Web Audio) ---- */
  $$('[data-ll-player]').forEach(function (pl) {
    var btn = $('.ll-play', pl), bars = $$('.ll-wave i', pl), src = pl.getAttribute('data-src'), audio, ctx, timer, t0, dur = 9;
    bars.forEach(function (b, i) { b.style.setProperty('--i', i); b.style.setProperty('--h', (30 + Math.abs(Math.sin(i * 1.7) * 55 + Math.cos(i * .6) * 15)) + '%'); });
    function progress(p) { var on = Math.round(p * bars.length); bars.forEach(function (b, i) { b.classList.toggle('on', i < on); }); }
    function stop() { btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', btn.getAttribute('data-label-play')); pl.classList.remove('is-playing'); clearInterval(timer); if (audio) audio.pause(); if (ctx) { ctx.close(); ctx = null; } progress(0); }
    function play() {
      btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', btn.getAttribute('data-label-pause')); pl.classList.add('is-playing');
      if (src) {
        audio = audio || new Audio(src); audio.currentTime = 0; audio.play();
        audio.onended = stop; timer = setInterval(function () { progress(audio.currentTime / (audio.duration || 1)); }, 100); return;
      }
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) { return; }
      ctx = new AC(); t0 = ctx.currentTime;
      /* gentle music-box lullaby, placeholder only */
      var notes = [67,72,71,72,74,72,71,69,67,0,69,71,72,74,76,74,72,71,72];
      notes.forEach(function (n, i) {
        if (!n) return;
        var o = ctx.createOscillator(), g = ctx.createGain(), t = t0 + i * 0.45;
        o.type = 'sine'; o.frequency.value = 440 * Math.pow(2, (n - 69) / 12);
        g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(0.16, t + 0.02); g.gain.exponentialRampToValueAtTime(0.001, t + 1.2);
        o.connect(g).connect(ctx.destination); o.start(t); o.stop(t + 1.3);
      });
      var start = Date.now();
      timer = setInterval(function () { var p = (Date.now() - start) / 1000 / dur; progress(p); if (p >= 1) stop(); }, 100);
    }
    btn.addEventListener('click', function () { btn.getAttribute('aria-pressed') === 'true' ? stop() : play(); });
  });

  /* ---- founding counter: reads data-claimed / data-cap (filled by Liquid from a real Shopify value) ---- */
  $$('[data-ll-counter]').forEach(function (c) {
    var claimed = parseInt(c.getAttribute('data-claimed'), 10), cap = parseInt(c.getAttribute('data-cap'), 10) || 100;
    if (isNaN(claimed)) { c.setAttribute('data-state', 'placeholder'); return; }
    claimed = Math.max(0, Math.min(cap, claimed));
    var fill = $('.ll-counter__fill', c), txt = $('[data-ll-counter-txt]', c), left = $('[data-ll-counter-left]', c);
    if (txt) txt.textContent = claimed + ' of ' + cap + ' founding families';
    if (left) left.textContent = (cap - claimed) + ' founding places left';
    var go = function () { fill.style.setProperty('--p', (claimed / cap * 100) + '%'); };
    if ('IntersectionObserver' in window) { var o = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { go(); o.disconnect(); } }); o.observe(c); } else go();
  });

  /* ---- founding deadline (31 Oct 2026, 23:59 US Eastern): live countdown; everything tied to it disappears afterwards, it never resets ---- */
  (function () {
    var cds = $$('[data-ll-countdown]'), until = $$('[data-ll-until-deadline]');
    if (!cds.length && !until.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = Date.now(), done = false;
      until.forEach(function (el) { if (now >= +el.getAttribute('data-ll-until-deadline')) { el.hidden = true; el.style.display = 'none'; done = true; } });
      cds.forEach(function (c) {
        var ms = +c.getAttribute('data-ll-countdown') - now; if (ms <= 0) return;
        var m = Math.floor(ms / 60000), dd = Math.floor(m / 1440), hh = Math.floor(m % 1440 / 60), mm = m % 60;
        $$('[data-ll-cd=d]', c).forEach(function (e) { e.textContent = dd; });
        $$('[data-ll-cd=h]', c).forEach(function (e) { e.textContent = c.classList.contains('ll-cd--compact') ? hh : pad(hh); });
        $$('[data-ll-cd=m]', c).forEach(function (e) { e.textContent = c.classList.contains('ll-cd--compact') ? mm : pad(mm); });
        c.setAttribute('aria-label', 'Founding price ends in ' + dd + ' days, ' + hh + ' hours and ' + mm + ' minutes');
      });
      return done;
    }
    tick(); setInterval(tick, 15000);
  })();

  /* ---- marquee pause button ---- */
  $$('[data-ll-mq-pause]').forEach(function (b) {
    var mq = b.closest('.ll-mq');
    b.addEventListener('click', function () {
      var p = mq.classList.toggle('is-paused'); b.setAttribute('aria-pressed', p ? 'true' : 'false');
      b.setAttribute('aria-label', p ? 'Play the moving banner' : 'Pause the moving banner');
    });
  });

  /* ---- preview-only: toggle "to confirm" markers ---- */
  var rt = $('.ll-review-toggle');
  if (rt) rt.addEventListener('click', function () { var h = d.body.classList.toggle('ll-hide-review'); rt.textContent = h ? 'Show "to confirm" marks' : 'Hide "to confirm" marks'; });
  if (/[?&]clean=1/.test(location.search)) { d.body.classList.add('ll-hide-review'); if (rt) rt.remove(); }
})();
